import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center mb-4" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-muted fw-bold fs-5"
}
const _hoisted_4 = {
  key: 1,
  class: "text-muted fw-bold fs-5"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "form-check form-check-custom form-check-solid form-check-lg m-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckboxLg"
}, null, -1)
const _hoisted_8 = { class: "d-flex justify-content-center mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalBase = _resolveComponent("ModalBase")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    title: "Manage Phone Number",
    ref: "modal",
    "is-loading": _ctx.isLoading,
    "loading-text": "Adding Phone Number"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
        (_ctx.mode === 'verify')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "We just sent a text with a code to your phone."))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, "Phone numbers must be able to receive text messages and verified to receive communication from StageHub."))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_InputGroup, {
          label: "Number",
          "is-required": true,
          class: "col-12 col-md-6"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.entity.number.$error}]),
              onMaska: _cache[0] || (_cache[0] = ($event: any) => (_ctx.entity.number = $event.target.dataset.maskRawValue)),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userPhone) = $event)),
              type: "tel"
            }, null, 34), [
              [_directive_maska, `1 (###) ###-####`],
              [_vModelText, _ctx.userPhone]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_InputGroup, {
          class: "col-12 col-md-6",
          label: "Receive Texts?"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: "",
                id: "flexCheckboxLg",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.entity.canReceiveTexts) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.entity.canReceiveTexts]
              ]),
              _hoisted_7
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.mode === 'add')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              type: "primary",
              onClick: _ctx.add,
              "is-loading": _ctx.isLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode("Add Number")
              ]),
              _: 1
            }, 8, ["onClick", "is-loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}